import { render, staticRenderFns } from "./PlanDesignsMinimizedCheckbox.vue?vue&type=template&id=f3095d8c&"
import script from "./PlanDesignsMinimizedCheckbox.vue?vue&type=script&lang=js&"
export * from "./PlanDesignsMinimizedCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports